
import Google from "../../../assets/duotone/Google.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GoogleIcon({ className, dataTestid = "GoogleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Google data-testid={dataTestid} className={classes} {...rest} />
  );
}
